import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IPushSubscriptionsResponse } from './push-subscriptions.interface';

@Injectable()
export class PushSubscriptionsService {

  constructor(private http: HttpClient) {}

  list(params?: { page?: number; per_page?: number; search?: string }): Observable<IPushSubscriptionsResponse> {
    let httpParams = new HttpParams();
    if (params?.page) httpParams = httpParams.set('page', String(params.page));
    if (params?.per_page) httpParams = httpParams.set('per_page', String(params.per_page));
    if (params?.search) httpParams = httpParams.set('search', params.search);

    return this.http.get<IPushSubscriptionsResponse>(
      `${environment.apiEndpoint}/push-subscriptions`,
      { params: httpParams }
    );
  }
}
